import OrdersPage from "@/pages/order/order-page";
import CreateOrderPage from "@/pages/order/create-order-page";
import OrderDetailPage from "@/pages/order/order-detail-page";
import SearchOrderPage from "@/pages/search-order";
import { route } from "../utils";
import { RouteType } from "../types";
import OrderInvoicePage from "@/components/orders/OrderInvoice";
import DetectionTestPage from "@/pages/order/detection-test-page";

// Define routes with semantic names - single source of truth
export const orderRoutes: Record<string, RouteType> = {
  list: route("/orders", OrdersPage),
  detect: route("/orders-detect", DetectionTestPage),
  new: route("/orders/new", CreateOrderPage),
  detail: route("/orders/:id", OrderDetailPage),
  invoice: route("/orders/invoices/:id", OrderInvoicePage),
  search: route("/search-order", SearchOrderPage),

};
